import * as React from 'react';
import classNames from 'classnames';
import IMPComponent from '../../interfaces/IMPComponent';

import './styles.scss';

interface IFormErrorProps extends IMPComponent {
  children: React.ReactNode;
}

const FormError: React.FunctionComponent<IFormErrorProps> = ({ className, ...props }) => {
  const cn = classNames('FormError', className);

  return <label className={cn} {...props} />;
};

export default React.memo(FormError);



// WEBPACK FOOTER //
// ./src/components/Form/FormError/index.tsx